module.exports = __webpack_public_path__ + "img/methodology_a.5dffd709.png";